import React from 'react';
import { FONTS } from '../../styles/tokens';

export type SourceType = 'zip' | 'github';

interface SourceTypeTabsProps {
  value: SourceType;
  onChange: (next: SourceType) => void;
  textPrimary: string;
  textSecondary: string;
  border: string;
  accent: string;
}

interface TabOption {
  id: SourceType;
  label: string;
}

const TABS: readonly TabOption[] = [
  { id: 'zip', label: 'Upload zip' },
  { id: 'github', label: 'From GitHub' },
];

/**
 * Two-pill switch for choosing between the zip-upload and GitHub-repo
 * sources at the top of the Upload step. Purely presentational; the parent
 * owns the active value.
 */
export function SourceTypeTabs(props: SourceTypeTabsProps): React.JSX.Element {
  return (
    <div style={{ display: 'inline-flex', gap: '6px', padding: '4px', borderRadius: '999px', border: `1px solid ${props.border}`, marginBottom: '16px' }}>
      {TABS.map(tab => {
        const active = props.value === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => props.onChange(tab.id)}
            style={{
              padding: '6px 14px', borderRadius: '999px', border: 'none',
              background: active ? props.accent : 'transparent',
              color: active ? '#FFF' : props.textSecondary,
              fontFamily: FONTS.heading, fontSize: '11px', letterSpacing: '0.15em', textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
